__turbopack_context__.v({
  "card": "HeritageShowcase-module__xA3llq__card",
  "collage": "HeritageShowcase-module__xA3llq__collage",
});
